import React, { FC, useRef, useState } from "react";
import Icon from "../../Elements/Icon/Icon.tsx";
import FolderActionsDropDown from "./FolderActionsDropDown.tsx";
import useOnClickOutside from "hooks/useOnClickOutside.js";
import { useMail } from "contexts/mailContext/mailContext.js";

type BreadcrumbElemProps = {
  folderId: number;
  folderData: {
    id: number;
    name: string;
  };
};

const BreadcrumbElem: FC<BreadcrumbElemProps> = ({ folderData, folderId }) => {
  const { setCurrentFolder, getCurrentFolder } = useMail();

  const currentFolderId = folderId || getCurrentFolder();

  const [showActions, setShowActions] = useState(false);

  const handleClick = (folderId: number) => {
    if (folderId === currentFolderId) {
      setShowActions((prev) => !prev);
    } else {
      setCurrentFolder(folderId);
    }
  };

  const ref = useRef();

  useOnClickOutside(ref, () => {
    setShowActions(false);
  });

  return (
    <div
      className={`breadcrumb-name ${
        folderData.id === currentFolderId ? "current" : ""
      }`}
      key={folderData.id}
      ref={ref}
    >
      <div className="breadcrumb-arrow">
        <Icon name="arrow-right" gray />
      </div>
      <div
        className="breadcrumb-text"
        onClick={() => handleClick(folderData.id)}
      >
        {folderData.name}
        {folderData.id === currentFolderId ? (
          getCurrentFolder() ? (
            <div className="breadcrumb-actions">
              <Icon name="arrow-down-solid" iconClass="dropdown-icon" />
              <FolderActionsDropDown
                folderId={currentFolderId}
                showActions={showActions}
              />
            </div>
          ) : null
        ) : null}
      </div>
    </div>
  );
};

export default BreadcrumbElem;
